import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";
import SectionServices from "./Sections/SectionServices.jsx";
import SectionContacts from "./Sections/SectionContacts.jsx";
import SectionProjects from "./Sections/SectionProjects.jsx";
import Layout from "../../Layout/Layout.jsx";

import componentsStyle from "../../assets/jss/material-kit-react/views/components.jsx";

import { withRouter } from "react-router";
import Flipp from "../../components/FlippingCard/FlippingCard.jsx";
import SectionSponsor from "./Sections/SectionSponsors.jsx";
import  '../../assets/css/main.css'

class Components extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: window.language.setLanguage(props.match.params.lang).components
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      language: window.language.setLanguage(newProps.match.params.lang)
        .components
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <Layout
        language={this.state.language}
        color="transparent"
        {...this.props}
      >
        <Parallax image={require("../../assets/img/slide1.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1 className={classes.title + ' bluec'}>
                    {this.state.language.maintitle}
                  </h1>
                  {/* <b><h3 className={classes.subtitle}>
                    {this.state.language.desc}
                  </h3></b> */}
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>

        <div className={classNames(classes.main) + ' main-container'}>
          <SectionServices
            {...this.state.language.services}
            lang={this.state.language.lang}
          />
          <Flipp
            {...this.state.language}
            match={this.props.match}
            history={this.props.history}
          />
          <SectionSponsor {...this.state.language.partners} />
          <SectionProjects
            {...this.state.language.news}
            lang={this.state.language.lang}
          />
          <SectionContacts {...this.state.language.contact} />
        </div>
      </Layout>
    );
  }
}

export default withRouter(withStyles(componentsStyle)(Components));



// WEBPACK FOOTER //
// ./src/views/Components/Components.jsx